import './usp-slider.scss';
import Swiper from 'swiper';
import 'swiper/css';

/**
 * Initialize USP sliders.
 * Can be called on initial page load or after AJAX content updates.
 *
 * @param {HTMLElement|Document} container - Container to search for sliders (defaults to document)
 */
export function initUspSliders( container = document ) {

	const sliders = container.querySelectorAll( '.js-usp-slider' );

	sliders.forEach( function( slider ) {
		
		// Skip if already initialized
		if ( slider.swiper ) {
			return;
		}
		
		new Swiper( slider, {
			spaceBetween: 20,
			initialSlide: 1,
			loop: true,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 3,
				},
			},
		} );
	} );

}

// Make function globally available for AJAX updates
if ( typeof window !== 'undefined' ) {
	window.initUspSliders = initUspSliders;
}

// Initialize on page load
document.addEventListener( 'DOMContentLoaded', function() {
	initUspSliders();
} );